import { FC, useEffect, useState } from 'react';
import { Spin } from 'antd';
import { useMethods } from '@lhb/hook';
import { isNotEmpty, isNotEmptyAny } from '@lhb/func';
import V2Title from '@/common/components/Feedback/V2Title';
import List from './List';
import SpotSurveyDetailDrawer from '@/views/expandstore/pages/spotsurveydetail/Drawer';

/**
 * @Description 机会点详情-踩点记录模块
 *
 */
const RelationSpotSurveys: FC<{
  detail: any,
}> = ({ detail }) => {
  const [filters, setFilters] = useState<any>({});
  const [hasData, setHasData] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [loaded, setLoaded] = useState<boolean>(false);
  const [detailDrawerData, setDetailDrawerData] = useState<any>({
    open: false,
    id: null
  });

  useEffect(() => {
    const { lng, lat } = detail || {};
    if (isNotEmpty(lng) && isNotEmpty(lat)) {
      setFilters({
        distance: 500,
        longitude: lng,
        latitude: lat,
      });
    }
  }, [detail]);

  const methods = useMethods({
    onClickDetail(record: any) {
      setDetailDrawerData({
        open: true,
        id: record.id,
      });
    },
  });

  return (!loaded || hasData) ? (<>
    <V2Title
      type='H2'
      divider
      text={'踩点记录'}
      className={'pt-16'}
    />
    {isNotEmptyAny(filters) && <Spin spinning={loading}>
      <List
        filters={filters}
        onClickDetail={methods.onClickDetail}
        setLoading={setLoading}
        setHasData={setHasData}
        setLoaded={setLoaded}
      />
    </Spin>}
    {/* 踩点记录详情抽屉 */}
    <SpotSurveyDetailDrawer
      drawerData={detailDrawerData}
      onClose={() => setDetailDrawerData({ open: false, id: null })}
    />
  </>
  ) : <></>;
};

export default RelationSpotSurveys;
